import { IGrauDeSessao } from './../../common/types/Evento'
import Vue, { markRaw } from 'vue'
import { defineStore } from 'pinia'

export type VCalendarType = Vue & {
	next: () => void,
	prev: () => void,
	getFormatter: (params: any) => any,
	checkChange: () => void,
	toToday: () => void,
}

// marcado como raw: o store não deve observar (nem desembrulhar nos tipos) a instância do v-calendar
type CalendarioRaw = ReturnType<typeof markRaw<VCalendarType>>

export const useAgendaStore = defineStore('agenda', {
	state: () => ({
		start: null as any,
		end: null as any,

		calendar: null as CalendarioRaw | null,

		filter: {
			potencia: null,
			loja: null,
			grau: null,
			tipoDaSessao: null,
		} as Filtro,

		tipoDaLabel: 'grau' as 'tipo' | 'grau',
	}),

	actions: {
		setCalendar(calendar: VCalendarType) {
			// instância de componente: não deve ser observada pelo store
			this.calendar = markRaw(calendar)
		},

		setInterval({ start, end }: { start: string, end: string }) {
			this.start = start
			this.end = end
		},

		setFilter(filter: Filtro) {
			this.filter = filter
		},

		setTipoDaLabel(tipo: 'tipo' | 'grau') {
			this.tipoDaLabel = tipo
		},
	},

	getters: {
		monthFormatter(): any {
			return this.calendar?.getFormatter({
				timeZone: 'UTC', month: 'long',
			})
		},

		year(): string {
			const { start } = this
			const startYear = start?.year || ''

			return `${startYear}`
		},

		month(): string {
			const { start } = this
			if (!start) return ''

			return this.monthFormatter(start)
		},

		textDate(): string {
			const currentYear = new Date().toISOString().split('-')[0]
			return currentYear === this.year
				? this.month
				: `${this.month.slice(0, 3)} de ${this.year}`
		},
	},
})

export type Filtro = {
	potencia: {
		value: string
		text: string,
	} | null
	loja: {
		value: string
		text: string,
	} | null,
	grau: IGrauDeSessao | null,
	tipoDaSessao: string | null,
}
